export default "__VITE_ASSET__E7qPK_$l__"